import React, { useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../data/landingContent";
export function FAQList() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="divide-y divide-[#dce4ed] border-y border-[#dce4ed]" data-id="element-65" data-mp="j1quy1x2usdt">
      {faqs.map(([question, answer], index) => {
      const isOpen = index === openIndex;
      return <div key={question} data-id="element-66" data-mp="a1lnjrrvvtzn" data-mpi={index}>
            <h3 data-id="element-67" data-mp="a2x1gkf1mi4h">
              <button type="button" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-base font-bold text-[#0a1b38] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0077e8]" data-id="element-68" data-mp="a3ew5cm24oaa">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#0077e8] transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-69" data-mp="3mjs9sv0yp3dh" />
              </button>
            </h3>
            {isOpen && <p className="max-w-2xl pb-5 pr-8 text-[15px] leading-7 text-[#526078]" data-id="element-70" data-mp="1ytuhglka1es1">{answer}</p>}
          </div>;
    })}
    </div>;
}